export default __webpack_public_path__ + "static/media/the-keys.f9661ef3.webp";